import { useParams } from "react-router-dom";
import FormLayoutHandler from "./FormLayoutHandler";
import { TFormHandlerParams } from "../../types/common";
import ModalFormHandler from "./ModalFormHandler";

const GenericForm = () => {
  const { id, source_id, draft_id, form_params } =
    useParams<keyof TFormHandlerParams>();
  return (
    <FormLayoutHandler
      key={source_id}
      id={id}
      source_id={source_id}
      draft_id={draft_id}
      form_params={form_params}
    />
  );
};

export const GenericFormModal = ({ options, ...rest }: { options: any }) => {
  const { dismiss }: any = rest || {};
  const { id, source_id, draft_id, form_params, ...additionalOptions } =
    options || {};
  return (
    <ModalFormHandler
      key={source_id}
      id={id}
      source_id={source_id}
      draft_id={draft_id}
      form_params={form_params}
      additionalOptions={additionalOptions}
      dismiss={dismiss}
      {...rest}
    />
  );
};

export default GenericForm;
